import { FormEvent } from 'react';
import * as React from 'react';
import RawHtml from 'react-raw-html';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push, replace } from 'redux-router';
import {
  apiStatuses,
  productInfoDeferred,
  validationErrors,
  fetchUserInfoDeferred
} from '../actions/Actions';
import {
  IAddress,
  IPaymentDetails,
  IProductInfo,
  IReferer,
  ISessionInfo,
  IUserInfo,
  Push,
  Replace
} from '../CustomTypes';
import { createAddCardUrl, createB64data } from '../fastflowUtils';
import LegalAge from '../gdpr/LegalAge';
import { svgPaymentCard } from '../icons';
import { Button, PaymentMethods } from '../input-components/InputComponents';
import { sccPulseTrackPageView } from '../PulseUtils';
import './SelectPaymentMethod.scss';

export interface IStateProps {
  address: IAddress;
  b64data?: string;
  basename?: string;
  error?: string;
  paymentMethodId?: number;
  paymentType: string;
  productInfo: IProductInfo;
  referer: IReferer;
  sessionInfo: ISessionInfo;
  userInfo: IUserInfo;
  __rct?: string;
}

export interface IDispatchProps {
  push?: Push;
  replace?: Replace;
}

export interface IProps extends IDispatchProps, IStateProps {}

export interface IState {
  showSelectPaymentMethodWarning: boolean;
  paymentType: string;
}

export class SelectPaymentMethod extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.hasSelectedPaymentCardThatExists = this.hasSelectedPaymentCardThatExists.bind(
      this
    );
    this.hasPaymentMethods = this.hasPaymentMethods.bind(this);
    this.setSelectedPaymentMethod = this.setSelectedPaymentMethod.bind(this);
    this.getSpidIdAndSigURIParamsIfInUrl = this.getSpidIdAndSigURIParamsIfInUrl.bind(
      this
    );
    this.getSigIfInUrl = this.getSigIfInUrl.bind(this);
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
    this.createB64data = this.createB64data.bind(this);
    this.createAddCardUrlWithParams = this.createAddCardUrlWithParams.bind(
      this
    );
    this.goToAddCardUrl = this.goToAddCardUrl.bind(this);
    this.state = {
      paymentType: this.props.paymentType,
      showSelectPaymentMethodWarning: false
    };
  }

  public componentWillMount() {
    this.componentWillReceiveProps(this.props);
  }

  public componentDidMount() {
    productInfoDeferred.promise.then(product => {
      const eventName = 'Secure payment';
      fetchUserInfoDeferred.promise
        .then(user => {
          sccPulseTrackPageView(product, user, eventName);
        })
        .catch(() => {
          sccPulseTrackPageView(product, this.props.userInfo, eventName);
        });
    });
  }

  public componentWillReceiveProps(nextProps: IProps) {
    if (
      !nextProps.paymentMethodId &&
      nextProps.userInfo &&
      nextProps.userInfo.paymentMethods &&
      nextProps.userInfo.paymentMethods.length > 0
    ) {
      this.setSelectedPaymentMethod(nextProps.userInfo.paymentMethods[0]);
    }
  }

  public render() {
    const {
      header,
      text2,
      price,
      productId,
      paymentMethodCompanyPays
    } = this.props.productInfo;
    const hasPaymentMethods = this.hasPaymentMethods();
    let subHeader = this.props.productInfo.subHeader;
    if (!subHeader) {
      subHeader = `kr ${price},-`;
    }

    const companyPaysUrl = `/products/${productId}/companypays?${this.getSpidIdAndSigURIParamsIfInUrl()}`;

    return (
      <div className="container payment">
        <h1>{svgPaymentCard()}</h1>
        <h1>Betalingsinformasjon</h1>
        <form onSubmit={this.onSubmit}>
          <div className="mask ">
            <p className="productHeader">
              {header} - {subHeader}
            </p>
            <div className="bullets">
              <RawHtml.span>{text2}</RawHtml.span>
            </div>

            {hasPaymentMethods && (
              <PaymentMethods
                paymentMethods={this.props.userInfo.paymentMethods}
                selectedPaymentMethodId={this.props.paymentMethodId}
                userLoggedIn={
                  this.props.sessionInfo.apiStatus === apiStatuses.ERROR
                }
                owningClient={this.props.userInfo.sig}
                addCardUrl={`${this.createAddCardUrlWithParams()}&returnToSelectPaymentMethod=false`}
                setSelectedPaymentMethod={this.setSelectedPaymentMethod}
                showSelectPaymentMethodWarning={
                  this.state.showSelectPaymentMethodWarning
                }
                showPurchaseFailedWarning={
                  this.props.error &&
                  this.props.error === validationErrors.PURCHASE_FAILED
                }
              />
            )}
          </div>
          {hasPaymentMethods && (
            <Button
              type="submit"
              className={
                paymentMethodCompanyPays && 'button-complete-company-pays'
              }
            >
              Fullfør bestillingen
            </Button>
          )}
          {paymentMethodCompanyPays && (
            <div>
              <Button
                onClick={() =>
                  this.props.push(companyPaysUrl + '&__rct=' + this.props.__rct)
                }
                className={'company-pays-button'}
              >
                Send faktura til arbeidsgiver
              </Button>
            </div>
          )}
          {!hasPaymentMethods && (
            <Button onClick={this.goToAddCardUrl}>Gå til betaling</Button>
          )}
        </form>
        <LegalAge />
      </div>
    );
  }

  private createB64data() {
    if (this.props.b64data) {
      return `&b64data=${encodeURIComponent(this.props.b64data)}`;
    }

    const b64data = createB64data(
      this.props.address,
      this.props.referer,
      this.props.userInfo.phoneNumber,
      false,
      this.props.userInfo.email
    );
    return `&b64data=${encodeURIComponent(b64data)}`;
  }

  private onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    if (!this.hasSelectedPaymentCardThatExists()) {
      this.setState({ showSelectPaymentMethodWarning: true });
      return false;
    }
    this.setState({ showSelectPaymentMethodWarning: false });

    const { productId } = this.props.productInfo;

    let rctParam = '';
    if (this.props.__rct) {
      rctParam = `&__rct=${this.props.__rct}`;
    }
    this.props.push(
      `/products/${productId}/placeorder?paymentMethodId=${
        this.props.paymentMethodId
      }${this.getSpidIdAndSigURIParamsIfInUrl()}${this.createB64data()}&paymentType=${
        this.state.paymentType
      }${rctParam}`
    );
  }

  private hasSelectedPaymentCardThatExists() {
    if (!this.props.paymentMethodId || !this.hasPaymentMethods()) {
      return false;
    }
    return this.props.userInfo.paymentMethods.some(
      card => card.id === this.props.paymentMethodId
    );
  }

  private hasPaymentMethods() {
    return (
      this.props.userInfo.paymentMethods &&
      this.props.userInfo.paymentMethods.length > 0
    );
  }

  private setSelectedPaymentMethod(method: IPaymentDetails) {
    this.setState({ paymentType: method.type });
    const url = `/products/${
      this.props.productInfo.productId
    }/selectpaymentmethod/${
      method.id
    }?${this.getSpidIdAndSigURIParamsIfInUrl()}${this.createB64data()}&__rct=${
      this.props.__rct
    }`;
    this.props.replace(url);
  }

  private getSpidIdAndSigURIParamsIfInUrl() {
    if (this.props.sessionInfo.apiStatus === apiStatuses.ERROR) {
      // Not logged in, so save sig/spidId in case of reload
      const { spidId, sig } = this.props.userInfo;
      return `&spidId=${spidId}&sig=${sig}`;
    }
    return '';
  }

  private getSigIfInUrl() {
    if (this.props.sessionInfo.apiStatus === apiStatuses.ERROR) {
      // Not logged in, so save sig/spidId in case of reload
      const { sig } = this.props.userInfo;
      return `&sig=${sig}`;
    }
    return '';
  }

  private createAddCardUrlWithParams() {
    const { owningClient, productId } = this.props.productInfo;
    const { spidId, email } = this.props.userInfo;
    return `${createAddCardUrl(
      owningClient,
      productId,
      spidId,
      email
    )}${this.getSigIfInUrl()}${this.createB64data()}`;
  }

  private goToAddCardUrl() {
    productInfoDeferred.promise.then(product => {
      sccPulseTrackPageView(product, this.props.userInfo, 'Click to payment');
    });
    window.location.href = this.createAddCardUrlWithParams();
  }
}

export default connect<IStateProps, IDispatchProps, {}>(
  state => ({
    __rct: state.router.location.query.__rct,
    address: state.address,
    b64data: state.router.location.query.b64data,
    basename: state.router.location.basename,
    error: state.router.location.query.error,
    paymentMethodId:
      state.router.params.paymentMethodId &&
      parseInt(state.router.params.paymentMethodId, 10),
    paymentType: state.router.params.paymentType,
    productInfo: state.productInfo,
    referer: state.referer,
    sessionInfo: state.sessionInfo,
    userInfo: state.userInfo
  }),
  dispatch => bindActionCreators({ replace, push }, dispatch)
)(SelectPaymentMethod);



// WEBPACK FOOTER //
// ./src/page-components/SelectPaymentMethod.tsx